import React, { useState, useEffect } from "react";
import styled, { css } from "styled-components";
import breakpoints from "../../../styles/breakpoints";
import { transition } from "../../../styles/variables";

export const Image = styled.img<{
  height: string;
  xsDownHeight: string;
  width: string;
  objectFit: string;
  zoomScale: number;
  isPartOfGallery: boolean;
}>`
  height: ${(props) => props.height};
  width: ${(props) => props.width};
  object-fit: ${(props) => props.objectFit};
  ${breakpoints.xsDown} {
    height: ${(props) => props.xsDownHeight};
  }
  transition: ${transition.subMenuTransition};
  ${(props) => css`
    transform: scale(${props.zoomScale});
  `};
  overflow: visible;
  ${(props) =>
    props.isPartOfGallery &&
    css`
      position: relative;
      bottom: 15px;
    `};
`;

export interface ImageWithZoomProps {
  photoSrc: string;
  height: string;
  xsDownHeight: string;
  width: string;
  objectFit: string;
  disableZoom?: boolean;
  isPartOfGallery?: boolean;
  zoomScale: number;
}

const ImageWithZoom = ({
  photoSrc,
  height,
  xsDownHeight,
  width,
  objectFit,
  disableZoom = false,
  zoomScale,
  isPartOfGallery = false,
}: ImageWithZoomProps) => {
  const [hasClicked, setHasClicked] = useState<boolean>(false);

  useEffect(() => {
    if (disableZoom) {
      setHasClicked(false);
    }
  }, [disableZoom]);

  const zoomScaleForImage = !disableZoom && hasClicked ? zoomScale : 1;

  return (
    <Image
      src={photoSrc}
      width={width}
      height={height}
      xsDownHeight={xsDownHeight}
      objectFit={objectFit}
      zoomScale={zoomScaleForImage}
      onClick={() => !disableZoom && setHasClicked(!hasClicked)}
      isPartOfGallery={isPartOfGallery}
    />
  );
};

export default ImageWithZoom;
